import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import moment from "moment";

import { makeStyles } from "@mui/styles";
import logo from "../../assets/images/logo.png";
import { LocationCity } from "@mui/icons-material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { IconButton } from "@mui/material";
import {
  featuredJobs,
  formatEducationRequired,
  jobs,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import WorkIcon from "@mui/icons-material/Work"; // Import job-related icon
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import PostJobModal from "../../components/popUp/PostJobPopUp";
import PostJobDetail from "../../components/popUp/PostJobDetail";
import {
  _get_job_feed_list_blog_api,
  delete_live_job_feed_api,
  favourite_live_job_api,
  get_outside_jobs_api,
} from "../../DAL/partner/partners";
import { useSnackbar } from "notistack";
import { useIds } from "../../hook/AdminContext";
import PageLoading from "../../components/loader/PageLoading";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import PostJoboUTSIDE from "./PostJobOutSide";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import { s3baseUri } from "../../config/config";
import JobSkeleton from "../../components/loader/HJobsSkeletin";
import RecordNoImage from "../../components/recordNotFound/RecordNoImage";
import { scroller } from "react-scroll";

const useStyles = makeStyles(() => ({
  loading: {
    margin: "auto",
  },
}));

export default function GroupsFeeds({ loading, setLoading }) {
  const [data, setData] = useState([]);
  const location = useLocation();
  const pageTitles = {
    "/warehouse": "Warehouse  Jobs",
    "/warehouse": "Warehouse  Jobs",
    "/healthcare": "Healthcare Jobs",
    "/hospitality": "Hospitality jobs",
    "/office-source": "Office Source Jobs",
    "/retail-source": "Retail Source Jobs",
    "/food-source": "Food Source Jobs",
    "/fit-out-source": "Fit Out Source Jobs",
    "/construction-source": "Construction Jobs",
  };
  const pageTitle = pageTitles[location?.pathname] || "Live Jobs";

  const navigate = useNavigate();
  const [selectedJob, setSelectedJob] = useState(null);
  const { findId, setBreadCrumb, userInfo, isRefresh } = useIds();
  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();
  const [loadMorePath, setLoadMorePath] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");
  const scrollRef = useRef(null); // Reference to the scrollable container
  const [isHovered, setIsHovered] = useState(false);

  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [isScrolling, setIsScrolling] = useState(false);

  // const [loading, setLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const apiData = localStorage.getItem("side_bar_data");
  let data_array = apiData ? JSON.parse(apiData) : null;

  const [selectedFilter, setSelectedFilter] = useState(
    data_array?.[0]?._id || ""
  );

  const load_more_path = "api/jobs/list?page=0&limit=50";

  const [cv, setCv] = useState(null);
  const [sourceId, setsourceId] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [partnersObj, setPartnersObj] = useState({});
  const [editMode, setEditMode] = useState(false);

  const classes = useStyles();
  const pathname = location.pathname;

  const [open, setOpen] = useState(false);

  const isMobile = useMediaQuery("(max-width:600px)", { noSsr: true });
  const isSmallMobile = useMediaQuery("(max-width:600px)", { noSsr: true }); // iPhone size
  const handleNavigateAppliedJobs = () => {
    console.log("callled");
    navigate(`/${firstSegment}/applied-jobs`, { state: { routePath: "home" } });
  };

  const fetchCategories = async (path, search, loading, id) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    if (firstSegment === "home") {
      id = "";
    } else {
      id = localStorage.getItem("source_id") || findId;
    }
    console.log(localStorage.getItem("source_id"), "asxkmsource_idsource_id");

    const response = await get_outside_jobs_api(id, search, path);
    console.log(response, "responseresponseresponse");

    for (let i = 0; i < response.jobs?.length; i++) {
      for (let j = 0; j < response.jobs[i].job_applicants.length; j++) {
        if (
          user_info?.user_id?._id ===
          response.jobs[i]?.job_applicants[j]?.userId
        ) {
          response.jobs[i].created_by_me = true;
        }
      }
    }

    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setsourceId(response.created_for);

      if (loading) {
        let new_array = categories.concat(response.jobs);
        setCategories(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.jobs);
        setPageNumber(1);
      }

      setPartnersObj(response.jobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = () => {
    setIsLoadingMore(true);

    fetchCategories(loadMorePath, searchTerm, true, findId);
  };

  let login_nfo = localStorage.getItem("user");

  let user_info = login_nfo ? JSON.parse(login_nfo) : null; // Safely parse JSON if data exists
  console.log(user_info, "Parsed user_info");
  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );

  useEffect(() => {
    if (!loading) {
      const timeoutId = setTimeout(() => {
        fetchCategories(loadMorePath, searchTerm, false, findId);
      }, 800);
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm, location.pathname]); // Add pathname to dependencies

  useEffect(() => {
    fetchCategories(load_more_path, searchTerm, false, findId);
  }, [location.pathname, isRefresh]); // Add pathname to dependencies

  // useEffect(() => {
  //   setBreadCrumb([
  //     {
  //       name: `${show_proper_words(firstSegment)}`,
  //       path: `/${firstSegment}`,
  //       active: false,
  //     },
  //     {
  //       name: `Job Feeds`,
  //       path: "",
  //       active: true,
  //     },
  //   ]);
  // }, []);
  const handleDeleteMember = async (id) => {
    // ID as parameter lein
    setLoading(true);
    console.log("Deleting Member ID:", id);

    const response = await delete_live_job_feed_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      fetchCategories(load_more_path, searchTerm, false, findId);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
  };

  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);
  const handleBookmarkToggle = (jobId) => {
    console.log(jobId, "jobIdjobIdjobIdjobId");

    const newBookmarkedState = !bookmarkedJobs[jobId];

    setBookmarkedJobs((prev) => {
      const updatedBookmarks = { ...prev, [jobId]: newBookmarkedState };
      localStorage.setItem("bookmarkedJobs", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        console.log("API Response:", response);

        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };

  // useEffect(() => {
  //   const scrollContainer = scrollRef.current;
  //   if (!scrollContainer) return;
  //   if (typeof window !== "undefined" && window.innerWidth <= 768) return;

  //   const interval = setInterval(() => {
  //     if (isHovered || isScrolling) return;

  //     const scrollTop = scrollContainer.scrollTop;
  //     const scrollHeight = scrollContainer.scrollHeight;
  //     const clientHeight = scrollContainer.clientHeight;

  //     const nearBottom = scrollTop + clientHeight >= scrollHeight - 5;

  //     if (nearBottom && categories.length > 0) {
  //       setIsScrolling(true);
  //       console.log("Reached bottom, scrolling to top");

  //       scrollContainer.scrollTo({ top: 0, behavior: "smooth" });

  //       setTimeout(() => {
  //         setIsScrolling(false);
  //       }, 1200);
  //     } else {
  //       scrollContainer.scrollTop += 1;
  //     }
  //   }, 30);

  //   return () => clearInterval(interval);
  // }, [isHovered, categories.length, isScrolling]);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollInterval = null;
    let resumeTimeout = null;
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(
      navigator.userAgent
    );

    const resetScrollToTop = () => {
      // Pause at the bottom for 3 seconds before scrolling back to top
      setIsScrolling(true);

      setTimeout(() => {
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          // Temporarily disable smooth scrolling for the reset
          scrollContainer.style.scrollBehavior = "smooth";
          scrollContainer.scrollTop = 0;

          // Trigger reflow
          void scrollContainer.offsetHeight;

          // Re-enable smooth scrolling
          setTimeout(() => {
            scrollContainer.style.scrollBehavior = "smooth";
            setIsScrolling(false);
          }, 2000);
        });
      }, 3000); // 3 second delay at the bottom before scrolling back to top
    };

    const startScroll = () => {
      scrollInterval = setInterval(() => {
        if (isHovered || isScrolling) return;

        const atBottom =
          Math.ceil(scrollContainer.scrollTop + scrollContainer.clientHeight) >=
          scrollContainer.scrollHeight - 5;

        if (atBottom && categories.length > 0) {
          resetScrollToTop(); // Wait 3 seconds then reset to top
        } else {
          // Smoother scrolling for mobile devices
          if (isMobileDevice) {
            scrollContainer.scrollBy({
              top: 1,
              behavior: "smooth",
            });
          } else {
            scrollContainer.scrollTop += 1;
          }
        }
      }, 20);
    };

    let lastTouchTime = 0;

    const stopScrollTemporarily = () => {
      const now = Date.now();
      if (now - lastTouchTime < 300) return; // debounce
      lastTouchTime = now;

      setIsScrolling(true);
      clearInterval(scrollInterval);
      clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(() => {
        setIsScrolling(false);
        startScroll();
      }, 2000);
    };
    const startScrollOnTouchEnd = () => {
      setTimeout(() => {
        setIsScrolling(false);
      }, 3000);
    };

    // Set initial smooth scrolling behavior
    scrollContainer.style.scrollBehavior = "smooth";
    startScroll();

    scrollContainer.addEventListener("touchstart", stopScrollTemporarily, {
      passive: true, // Changed to true for better performance
    });
    scrollContainer.addEventListener("touchend", startScrollOnTouchEnd, {
      passive: true, // Changed to true for better performance
    });

    return () => {
      clearInterval(scrollInterval);
      clearTimeout(resumeTimeout);
      scrollContainer.removeEventListener("touchstart", stopScrollTemporarily);
      scrollContainer.removeEventListener("touchend", startScrollOnTouchEnd);
    };
  }, [isHovered, categories, isScrolling]);

  if (loading) {
    return <JobSkeleton />;
  }

  // useEffect(() => {
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenDetail = (job) => {
    navigate(`/${firstSegment}/feed-job-detail/${job._id}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const handleCandidates = (job) => {
    navigate(`/${firstSegment}/candidates/${job._id}`, {
      state: { data: job },
    });
  };
  const handleOpenEditJob = (job) => {
    setEditMode(true);
    setSelectedJob(job);
    setOpen(true);
  };

  const handleOpen = () => {
    setOpen(true);
    setEditMode(false);
  };

  const handleDelete = (row) => {
    console.log(row._id, "rowrowrow");
    setDeletingMemberId(row._id);
    setDeleteDialogOpen(true);
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick(row) {
        handleOpenEditJob(row);
      },
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: (row, index) => handleDelete(row),
    },
  ];
  const OnclickOnMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <>
      <PostJoboUTSIDE
        refreshlist={fetchCategories}
        loadMorePath={load_more_path}
        searchTerm={searchTerm}
        loadingstate={loading}
        id={findId}
        open={open}
        handleClose={handleClose}
        editMode={editMode}
        jobData={selectedJob}
        sourceId={sourceId}
      />
      <div
        className="col-12 d-flex flex-wrap align-items-center justify-content-between small-button-job  p-2 margin-lef-right "
        style={{
          backgroundColor: "#fff",
          width: isSmallMobile ? "100%" : isMobile ? "100%" : "100%",
          borderRadius: "5px",
          marginRight: isMobile ? "2px" : "",
          overflow: "hidden",
          marginLeft: "0px !important",
        }}
      >
        <h4
          className="groups-text mb-2"
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            marginLeft: isMobile ? "14px" : "0",
            flex: "1 1 auto",
          }}
        >
          {pageTitle}
        </h4>
        {user_info?.type === 1 && (
          <button
            className="job-post-button"
            onClick={handleNavigateAppliedJobs}
          >
            <CheckCircleOutlineIcon
              style={{
                fontSize: "18px",
                color: "#4CAF50",
              }}
            />{" "}
            Applied Jobs
          </button>
        )}
        {user_info.type === 2 && (
          <button
            className="d-flex align-items-center job-post-button"
            onClick={handleOpen}
            style={{ fontSize: "14px", gap: "4px" }}
          >
            <PostAddOutlinedIcon
              style={{ color: "#000080", fontSize: "17px" }}
            />
            Post Job
          </button>
        )}

        <div
          className="d-flex flex-wrap align-items-center gap-2"
          style={{
            justifyContent: isMobile ? "center" : "center",
            width: "100%",
          }}
        >
          {/* {user_info.type === 1 && (
            <button
              className="job-post-button"
              onClick={handleNavigateAppliedJobs}
            >
              <CheckCircleOutlineIcon
                style={{
                  fontSize: "18px",
                  color: "#4CAF50",
                }}
              />{" "}
              Applied Jobs
            </button>
          )} */}
        </div>
      </div>

      <div
        className="profile-cards px-3"
        ref={scrollRef}
        style={{
          maxWidth: "350px",
          paddingLeft: isMobile ? "52px" : "12px",
          paddingRight: isMobile ? "6px" : "12px",
          height: isMobile ? "100vh" : "94vh",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          paddingBottom: "50px",
        }}
      >
        <div className="community-left-sidebar ">
          <div
            className="row "
            style={{
              marginLeft: isMobile ? "2px" : "",
              marginRight: isMobile ? "2px" : "",
            }}
          >
            <>
              <div className="col-12 mb-1 ">
                <div className="group-card">
                  <div className="card-body p-2">
                    {categories.length === 0 ? (
                      <RecordNoImage title="No jobs Found" />
                    ) : (
                      <div className="row">
                        {categories.map((job) => {
                          return (
                            <Card
                              onClick={
                                OnclickOnMobile
                                  ? () => handleOpenDetail(job)
                                  : undefined
                              }
                              // onMouseEnter={() => setIsHovered(true)}

                              // onMouseLeave={() => setIsHovered(false)}
                              {...(!OnclickOnMobile && {
                                onMouseEnter: () => setIsHovered(true),
                                onMouseLeave: () => setIsHovered(false),
                              })}
                              variant="outlined"
                              className="mui-card"
                              sx={{
                                borderRadius: 2,
                                mb: 2,
                                border: "2px solid #DAA520 !important",
                                position: "relative",
                                cursor: "pointer",
                              }}
                            >
                              {job.created_by === user_info?.user_id?._id && (
                                <Chip
                                  label="My Job"
                                  color="success"
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    left: -10,
                                    transform: "rotate(-30deg)",
                                    height: "16px",
                                    minWidth: "70px",
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                    lineHeight: "14px",
                                    zIndex: 1,
                                    fontSize: "9px",
                                  }}
                                />
                              )}
                              <CardContent
                                className="mui-card-content"
                                sx={{ padding: "2px !important" }}
                              >
                                {/* Header Section */}
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      {/* Business Icon Container */}
                                      <Box
                                        onClick={() => handleOpenDetail(job)}
                                        sx={{
                                          width: 35,
                                          height: 35,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                          borderRadius: "5px", // Optional: for rounded corners
                                          position: "relative",
                                        }}
                                      >
                                        <Avatar
                                          src={
                                            s3baseUri +
                                            job?.creater_info?.profile_image
                                          }
                                          alt=""
                                          style={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: "50%", // Optional: makes it circular like a typical profile icon
                                            objectFit: "cover",
                                          }}
                                        />
                                        {/* Inactive Chip - Positioned on Top of the Icon */}
                                      </Box>
                                    </Box>

                                    <Box>
                                      <Typography
                                        onClick={() => handleOpenDetail(job)}
                                        className="mui-typo"
                                        variant="h6"
                                        fontWeight="bold"
                                        sx={{ cursor: "pointer" }}
                                      >
                                        {job.jobTitle}
                                      </Typography>
                                      <Typography
                                        sx={{ cursor: "pointer" }}
                                        onClick={() => handleOpenDetail(job)}
                                        variant="body2"
                                        color="textSecondary"
                                      >
                                        {job.location} •{" "}
                                        <span
                                          style={{
                                            color: "navy",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {moment(job.createdAt).fromNow()}
                                        </span>
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <div className="d-flex align-items-center  responsive-chip-icons">
                                    {userInfo?.type === 1 && (
                                      <IconButton
                                        sx={{
                                          paddingRight: "0px !important",
                                          paddingTop: "4px !important",
                                          paddingBottom: "0px !important",
                                          fontSize: "10px !important",
                                        }}
                                        onClick={() =>
                                          handleBookmarkToggle(job._id)
                                        }
                                      >
                                        {bookmarkedJobs[job._id] ? (
                                          <BookmarkIcon
                                            className="responsive-icon"
                                            sx={{
                                              color: "#000080",
                                              paddingRight: "0px !important",
                                            }}
                                          />
                                        ) : (
                                          <BookmarkBorderIcon
                                            sx={{}}
                                            className="responsive-icon"
                                          />
                                        )}
                                      </IconButton>
                                    )}

                                    {job.created_by ===
                                      user_info?.user_id?._id && (
                                      <CustomPopoverSection
                                        menu={MENU_OPTIONS}
                                        data={job}
                                      />
                                    )}
                                  </div>
                                </Box>

                                {/* Job Tags */}
                                <Box
                                  sx={{ cursor: "pointer" }}
                                  display="flex"
                                  gap={1}
                                  my={2}
                                  onClick={() => handleOpenDetail(job)}
                                >
                                  {" "}
                                  <Chip
                                    className="mui-chip"
                                    label={job.jobType}
                                    variant="outlined"
                                  />
                                  <Chip
                                    className="mui-chip"
                                    // label={job.experienceRequired}
                                    label={show_des_data(
                                      job?.experienceRequired
                                    )}
                                    variant="outlined"
                                  />
                                  {/* <Chip
              className="mui-chip"
              // label={job.experienceRequired}
              label={formatEducationRequired(
                job?.educationRequired
              )}
              variant="outlined"
            /> */}
                                </Box>

                                {/* Additional Info */}
                                <Typography
                                  variant="body1"
                                  sx={{
                                    mt: 2,
                                    fontSize: "15px",
                                    cursor: "pointer",
                                    display: "inline",
                                    mb: 0,
                                  }}
                                  onClick={() => handleOpenDetail(job)}
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        job.description.length > 150
                                          ? `${job.description.slice(
                                              0,
                                              150
                                            )}...`
                                          : job.description,
                                    }}
                                  />

                                  {job.description.length > 150 && (
                                    <span
                                      style={{
                                        color: "navy",
                                        cursor: "pointer",
                                        textDecoration: "underline", // Added this line
                                      }}
                                      onClick={() => handleOpenDetail(job)}
                                    >
                                      Read More
                                    </span>
                                  )}
                                </Typography>

                                {/* Salary & Apply Button */}
                                <Box
                                  display="flex"
                                  flexDirection={isMobile ? "column" : "row"}
                                  justifyContent="space-between"
                                  alignItems={isMobile ? "stretch" : "center"}
                                  gap={1}
                                  mt={2}
                                >
                                  <Chip
                                    className="mui-chip"
                                    variant="outlined"
                                    sx={{
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                      width: "100%",
                                      fontSize: "0.8rem",
                                      padding: "4px 8px",
                                    }}
                                    label={
                                      job.salaryType?.toLowerCase() ===
                                        "fixed" ||
                                      job.salaryType?.toLowerCase() === "fix"
                                        ? `Fixed Salary: €${
                                            job.fixedSalary || job.salary
                                          }/${
                                            job?.frequencySalary === "Monthly"
                                              ? "month"
                                              : job?.frequencySalary ===
                                                "Yearly"
                                              ? "year"
                                              : job?.frequencySalary ===
                                                "Anually"
                                              ? "annually"
                                              : job?.frequencySalary ===
                                                "Weekly"
                                              ? "week"
                                              : job?.frequencySalary === "Daily"
                                              ? "day"
                                              : job?.frequencySalary ===
                                                "Hourly"
                                              ? "hour"
                                              : ""
                                          }`
                                        : `Max Salary: €${job.maxSalary}/${
                                            job?.frequencySalary === "Monthly"
                                              ? "month"
                                              : job?.frequencySalary ===
                                                "Yearly"
                                              ? "year"
                                              : job?.frequencySalary ===
                                                "Anually"
                                              ? "annually"
                                              : job?.frequencySalary ===
                                                "Weekly"
                                              ? "week"
                                              : job?.frequencySalary === "Daily"
                                              ? "day"
                                              : job?.frequencySalary ===
                                                "Hourly"
                                              ? "hour"
                                              : ""
                                          }`
                                    }
                                    onClick={() => handleOpenDetail(job)}
                                  />

                                  {job.created_by === user_info?.user_id?._id &&
                                    user_info?.type === 2 && (
                                      <div className="position-relative">
                                        <div
                                          className="badge position-absolute"
                                          style={{
                                            top: "-7px",
                                            right: "-4px",
                                            backgroundColor: "#FF0000",
                                            color: "#fff",
                                            padding: "2px 6px",
                                            borderRadius: "12px",
                                            minWidth: "20px",
                                            textAlign: "center",
                                            fontSize: "12px",
                                            lineHeight: "1.2",
                                          }}
                                        >
                                          {job?.job_applicants?.length || 0}
                                        </div>
                                        <button
                                          onClick={() => handleCandidates(job)}
                                          className="small-button-contain-job-candidates"
                                          style={{
                                            width: isMobile ? "100%" : "auto",
                                          }}
                                        >
                                          Candidates
                                        </button>
                                      </div>
                                    )}

                                  {user_info.user_id._id !== job.created_by &&
                                    userInfo?.type === 1 &&
                                    (job.created_by_me ? (
                                      <span
                                        className="d-flex align-items-center"
                                        style={{ color: "#4CAF50" }}
                                      >
                                        <CheckCircleOutlineIcon
                                          style={{
                                            marginRight: "4px",
                                            fontSize: "18px",
                                          }}
                                        />
                                        Applied
                                      </span>
                                    ) : (
                                      userInfo.type === 1 && (
                                        <button
                                          onClick={() => handleOpenDetail(job)}
                                          className="small-button-contain-job"
                                          style={{
                                            width: isMobile ? "100%" : "auto",
                                          }}
                                        >
                                          Apply Job
                                        </button>
                                      )
                                    ))}
                                </Box>
                              </CardContent>
                            </Card>
                          );
                        })}
                        {totalPages >= pageNumber ? (
                          <div className="col-12 text-center mt-3">
                            <span
                              ref={lastBookElementRef}
                              className="mt-3"
                              onClick={loadMoreData}
                              id="load-more-feed"
                            >
                              {isLoadingMore ? (
                                <CircularProgress
                                  color="primary"
                                  size="1.5rem"
                                />
                              ) : (
                                "Load More"
                              )}
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <CustomConfirmation
                open={deleteDialogOpen}
                setOpen={setDeleteDialogOpen}
                title={"Are you sure you want to delete this job?"}
                handleAgree={() => handleDeleteMember(deletingMemberId)}
              />
            </>
          </div>
        </div>
      </div>
    </>
  );
}
